/* eslint-disable @typescript-eslint/no-unused-vars */
import { fetchSubtaskItemChangeStatusLogList } from '../../services/subtaskItemChangeStatusLogService';
import { FAILURE, REQUEST, SUCCESS } from '../../utils/actionTypeUtil';
import { pushNotificationMessage } from '../../views/components/Notification';
import { AppAction } from '../app';
import { call, debounce, put, takeLatest } from 'redux-saga/effects';
import { FETCH_SUBTASK_ITEM_CHANGE_STATUS_LOG_LIST } from './subtaskItemChangeStatusLog.actions';

function* fetchSubtaskItemChangeStatusLogListSaga(action: AppAction) {
  try {
    yield put({ type: REQUEST(action.type) });
    const response = yield call(fetchSubtaskItemChangeStatusLogList, action.payload);
    const { data, headers } = response;
    yield put({ type: SUCCESS(action.type), payload: { data, headers } });
  } catch (error) {
    const errorMessage: string = error.response.data.message;
    yield put({ type: FAILURE(action.type), payload: { errorMessage } });
    yield put(pushNotificationMessage({ message: errorMessage, type: 'error' }));
  }
}

export default function* watchSubtaskItemChangeStatusLog() {
  yield debounce(
    250,
    FETCH_SUBTASK_ITEM_CHANGE_STATUS_LOG_LIST,
    fetchSubtaskItemChangeStatusLogListSaga,
  );
}
